import React from 'react'

import { MerchantLookupTxSetFieldTypes } from 'types/merchanTxTypes'
import Form from './Form'

const Index: React.FC<{
  isMerchantLookupToggle: boolean
  setFieldValue: MerchantLookupTxSetFieldTypes
  title?: string;
  placeholder?: string;
}> = ({ isMerchantLookupToggle, setFieldValue, title , placeholder}): React.ReactElement => {
  if (!isMerchantLookupToggle) return <></>
  return <Form setFieldValue={setFieldValue} title={title} placeholder={placeholder}/>
}

export default Index
